<template>
  <settings-section
    :title="$t('INBOX_MGMT.GMAIL_SYNC.TITLE')"
    :sub-title="$t('INBOX_MGMT.GMAIL_SYNC.SUBTITLE')"
  >
    <p>
      {{ $t('INBOX_MGMT.GMAIL_SYNC.LAST_SYNCED_AT_LABEL') }}:
      <strong>{{ lastSyncedAtLabel }}</strong>
    </p>
    <woot-button
      color-scheme="warning"
      variant="smooth"
      :is-loading="isResetting"
      @click="resetSync"
    >
      {{ $t('INBOX_MGMT.GMAIL_SYNC.RESET_BUTTON') }}
    </woot-button>
  </settings-section>
</template>

<script>
import { mapGetters } from 'vuex';
import { format } from 'date-fns';
import alertMixin from 'shared/mixins/alertMixin';
import SettingsSection from 'dashboard/components/SettingsSection.vue';

export default {
  components: {
    SettingsSection,
  },
  mixins: [alertMixin],
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
    isResetting() {
      return this.uiFlags.isUpdatingIMAP;
    },
    lastSyncedAtLabel() {
      if (!this.inbox.imap_inbox_synced_at) {
        return this.$t('INBOX_MGMT.GMAIL_SYNC.NEVER_SYNCED');
      }
      return format(
        new Date(this.inbox.imap_inbox_synced_at),
        'dd/MM/yyyy HH:mm:ss'
      );
    },
  },
  methods: {
    async resetSync() {
      try {
        await this.$store.dispatch('inboxes/updateInboxIMAP', {
          id: this.inbox.id,
          channel: { imap_inbox_synced_at: null },
        });
        this.showAlert(this.$t('INBOX_MGMT.GMAIL_SYNC.RESET_SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(this.$t('INBOX_MGMT.GMAIL_SYNC.RESET_ERROR_MESSAGE'));
      }
    },
  },
};
</script>
